import React, { useEffect, useState, Component } from 'react';
import { useCurrency } from '../hooks/useCurrency';
export function StickyButton() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    formatPrice,
    isLoading
  } = useCurrency();
  useEffect(() => {
    const learningSection = document.getElementById('learning-content-section');
    const pricingSection = document.getElementById('pricing-section');
    if (!learningSection || !pricingSection) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target.id === 'learning-content-section') {
          if (entry.isIntersecting) setIsVisible(true);
        } else if (entry.target.id === 'pricing-section') {
          if (entry.isIntersecting) setIsVisible(false);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '-100px 0px 0px 0px'
    });
    observer.observe(learningSection);
    observer.observe(pricingSection);
    return () => observer.disconnect();
  }, []);
  const handleClick = () => {
    const variantId = '53162996171116';
    try {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          value: 14.99,
          currency: 'USD'
        });
      }
    } catch {}
    const qs = (window.location.search || '').replace(/^\?/, '');
    const returnTo = qs ? `/cart?${qs}` : '/cart';
    window.location.href = `https://sanarconsciente.com/cart/add` + `?id=${encodeURIComponent(variantId)}` + `&quantity=1` + `&return_to=${encodeURIComponent(returnTo)}`;
  };
  return <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 shadow-2xl border-t-2 border-[var(--accent-orange)]" style={{
    transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
    transition: 'transform 0.3s ease-out',
    willChange: 'transform',
    contain: 'layout style'
  }} data-id="element-285">
      <div className="max-w-7xl mx-auto px-4 py-4 md:py-5" data-id="element-286">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4" data-id="element-287">
          <div className="text-center md:text-left" data-id="element-288">
            <p className="text-lg md:text-xl lg:text-2xl font-black text-[var(--text-light)] mb-1" data-id="element-289">
              Método Jabones Artesanales
            </p>
            <p className="text-sm md:text-base text-[var(--text-gray)]" data-id="element-290">
              Solo{' '}
              <span className="font-bold text-[var(--accent-orange)]" data-id="element-291">
                {isLoading ? '...' : formatPrice(14.99)}
              </span>{' '}
              - Oferta por tiempo limitado
            </p>
          </div>
          <button onClick={handleClick} className="w-full md:w-auto bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] text-white font-bold px-8 py-4 md:px-10 md:py-5 rounded-xl text-base md:text-lg lg:text-xl uppercase tracking-wide shadow-xl hover:shadow-2xl transition-shadow duration-300" data-id="element-292">
            EMPEZAR AHORA
          </button>
        </div>
      </div>
    </div>;
}